/**
 * Audio utility functions for user feedback
 */

// Create an audio context (lazily initialized)
let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioContext;
};

/**
 * Play an error beep sound to alert the user of a failed scan
 * Generates a distinctive error tone using Web Audio API (copyright-free)
 */
export const playErrorBeep = (): void => {
  try {
    const ctx = getAudioContext();

    // Create oscillator for the tone
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    // Connect nodes
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    // Configure the error sound: high-pitched beep at 880Hz (A5 note)
    // Sine wave for a cleaner, more pleasant high-pitched sound
    oscillator.frequency.setValueAtTime(880, ctx.currentTime);
    oscillator.type = 'sine';

    // Configure volume envelope (300ms duration with fade out)
    gainNode.gain.setValueAtTime(0.3, ctx.currentTime);
    gainNode.gain.setValueAtTime(0.3, ctx.currentTime + 0.15);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);

    // Play the sound
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.3);
  } catch (error) {
    // Silently fail if audio is not supported or blocked
    console.warn('Unable to play error beep:', error);
  }
};
